__turbopack_context__.v({
  "score-gauge": "_d-JYW_score-gauge",
  "score-gauge--active": "_d-JYW_score-gauge--active",
  "score-gauge--secondary": "_d-JYW_score-gauge--secondary",
  "score-gauge--slim": "_d-JYW_score-gauge--slim",
  "score-gauge__indicator-base": "_d-JYW_score-gauge__indicator-base",
  "score-gauge__indicator-container": "_d-JYW_score-gauge__indicator-container",
  "score-gauge__indicator-fill": "_d-JYW_score-gauge__indicator-fill",
  "score-gauge__indicator-fill--range-one": "_d-JYW_score-gauge__indicator-fill--range-one",
  "score-gauge__indicator-fill--range-three": "_d-JYW_score-gauge__indicator-fill--range-three",
  "score-gauge__indicator-fill--range-two": "_d-JYW_score-gauge__indicator-fill--range-two",
  "score-gauge__indicator-fill--secondary": "_d-JYW_score-gauge__indicator-fill--secondary",
  "score-gauge__label": "_d-JYW_score-gauge__label",
  "score-gauge__score": "_d-JYW_score-gauge__score",
});
